// gimme: conversations-inbox-ui 06/10/2020 24a2e66917cc934433dd111db7e06fd02943ca6a

export const threadIdFromProps = (state, props) => props.threadId;